var _defs, _path, _circle, _circle2, _circle3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderConstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_287c991d1bf57c646ffb013e44b64484bc06780232a7abcf132cb116e55ed9e6",
    x1: 95.83,
    y1: 61.35,
    x2: 104.47,
    y2: 61.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_287c991d1bf57c646ffb013e44b64484bc06780232a7abcf132cb116e55ed9e6",
    x1: 76.96,
    y1: 118.41,
    x2: 101.01,
    y2: 118.41,
    xlinkHref: "#SVGID_0_287c991d1bf57c646ffb013e44b64484bc06780232a7abcf132cb116e55ed9e6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_287c991d1bf57c646ffb013e44b64484bc06780232a7abcf132cb116e55ed9e6",
    x1: 98.51,
    y1: 122.95,
    x2: 118.48,
    y2: 122.95,
    xlinkHref: "#SVGID_0_287c991d1bf57c646ffb013e44b64484bc06780232a7abcf132cb116e55ed9e6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_287c991d1bf57c646ffb013e44b64484bc06780232a7abcf132cb116e55ed9e6",
    x1: 115.98,
    y1: 128.8,
    x2: 129.29,
    y2: 128.8,
    xlinkHref: "#SVGID_0_287c991d1bf57c646ffb013e44b64484bc06780232a7abcf132cb116e55ed9e6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_287c991d1bf57c646ffb013e44b64484bc06780232a7abcf132cb116e55ed9e6",
    x1: 67.16,
    y1: 125.72,
    x2: 79.46,
    y2: 125.72,
    xlinkHref: "#SVGID_0_287c991d1bf57c646ffb013e44b64484bc06780232a7abcf132cb116e55ed9e6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_287c991d1bf57c646ffb013e44b64484bc06780232a7abcf132cb116e55ed9e6",
    x1: 67.16,
    y1: 123.24,
    x2: 129.29,
    y2: 123.24,
    xlinkHref: "#SVGID_0_287c991d1bf57c646ffb013e44b64484bc06780232a7abcf132cb116e55ed9e6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke MI_4L_gradient",
    stroke: "url(#SVGID_5_287c991d1bf57c646ffb013e44b64484bc06780232a7abcf132cb116e55ed9e6)",
    d: "M95.91 99.48v11.65M104.65 100.68v11.65"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_gradient",
    cx: 100.15,
    cy: 61.35,
    r: 3.07,
    stroke: "url(#SVGID_5_287c991d1bf57c646ffb013e44b64484bc06780232a7abcf132cb116e55ed9e6)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_gradient",
    cx: 100.15,
    cy: 71.35,
    r: 3.07,
    stroke: "url(#SVGID_5_287c991d1bf57c646ffb013e44b64484bc06780232a7abcf132cb116e55ed9e6)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_gradient",
    cx: 100.15,
    cy: 81.15,
    r: 3.07,
    stroke: "url(#SVGID_5_287c991d1bf57c646ffb013e44b64484bc06780232a7abcf132cb116e55ed9e6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_5_287c991d1bf57c646ffb013e44b64484bc06780232a7abcf132cb116e55ed9e6)",
    d: "M92.23 53.55h15.83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a MI_4L_gradient",
    d: "M78.21 122.69a11.12 11.12 0 0121.55-.37",
    stroke: "url(#SVGID_5_287c991d1bf57c646ffb013e44b64484bc06780232a7abcf132cb116e55ed9e6)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b MI_4L_gradient",
    d: "M99.76 122.32a11.12 11.12 0 0117.47 4",
    stroke: "url(#SVGID_5_287c991d1bf57c646ffb013e44b64484bc06780232a7abcf132cb116e55ed9e6)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "c MI_4L_gradient",
    d: "M117.23 126.3a7 7 0 013.71-1 7.1 7.1 0 017.1 7.1",
    stroke: "url(#SVGID_5_287c991d1bf57c646ffb013e44b64484bc06780232a7abcf132cb116e55ed9e6)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "d MI_4L_gradient",
    d: "M68.41 129.27a7.11 7.11 0 019.8-6.58",
    stroke: "url(#SVGID_5_287c991d1bf57c646ffb013e44b64484bc06780232a7abcf132cb116e55ed9e6)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "e MI_4L_gradient",
    d: "M78.21 122.69a11.12 11.12 0 0121.55-.37M99.76 122.32a11.12 11.12 0 0117.47 4M117.23 126.3a7 7 0 013.71-1 7.1 7.1 0 017.1 7.1M68.41 129.27a7.11 7.11 0 019.8-6.58",
    stroke: "url(#SVGID_5_287c991d1bf57c646ffb013e44b64484bc06780232a7abcf132cb116e55ed9e6)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main MI_4L_gradient",
    d: "M83.73 93.72l32.83-.53s-.53-8.47-5.69-11.65c0 0 3.31-28.07-10.72-39.85-14 11.78-10.73 39.85-10.73 39.85-5.16 3.18-5.69 11.65-5.69 11.65",
    stroke: "url(#SVGID_5_287c991d1bf57c646ffb013e44b64484bc06780232a7abcf132cb116e55ed9e6)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main MI_4L_gradient",
    stroke: "url(#SVGID_5_287c991d1bf57c646ffb013e44b64484bc06780232a7abcf132cb116e55ed9e6)",
    d: "M79.03 27.66h61.53V141.61H55.89V50.8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main MI_4L_gradient",
    stroke: "url(#SVGID_5_287c991d1bf57c646ffb013e44b64484bc06780232a7abcf132cb116e55ed9e6)",
    d: "M79.03 27.66L55.89 50.8h23.14V27.66z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderConstruction);
export default __webpack_public_path__ + "static/media/underConstruction.40e3934c3e7a8e2c0b38c98e05c1eb35.svg";
export { ForwardRef as ReactComponent };